module.exports = __webpack_public_path__ + "img/very-mik.0fd8daec.png";